import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private toastr: ToastrService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((res: HttpErrorResponse) => {
        // Skip global toast notifications for external gallery token endpoints
        // since the UI handles invalid/expired links gracefully with a dedicated page
        if (res.url && res.url.includes('/by-gallery-token/')) {
          Sentry.captureException(new Error(res.message));
          return throwError(res);
        }

        switch (res.status) {
          case 500:
            this.toastr.error('An Unexpected error occurred on the server. Please refresh and try again.', null, {
              closeButton: true,
              timeOut: 10000,
            });
            break;
          case 0:
          case 400:
            const msg =
              res?.error?.message || 'Something is wrong with your request. Please check the data and try again.';
            this.toastr.error(msg, null, {
              closeButton: true,
              timeOut: 10000,
            });
            break;
          case 403:
            if (res.url.endsWith('/api/user/me') || res.url.endsWith('/api/auth/renew')) {
              this.toastr.error(`Please enter your credentials again.`, null, {
                closeButton: true,
                timeOut: 3000,
              });

              if (!window.location.href.endsWith(`/login`)) {
                window.location.href = '/login';
              }
            } else if (!res.url.endsWith('/api/auth/login') && !res.url.includes('/api/auth/google/code')) {
              // Check if user is authenticated by looking for auth cookies
              const hasAuthCookie =
                document.cookie.includes('auth-token') || document.cookie.includes('impersonated-auth-token');
              if (hasAuthCookie) {
                this.toastr.error(`You don't have the required permissions to perform this action.`, null, {
                  closeButton: true,
                  timeOut: 10000,
                });
              }
            }
            break;
        }

        Sentry.captureException(new Error(res.message));
        return throwError(res);
      }),
    );
  }
}
